module.exports = __webpack_public_path__ + "img/speed-bad.b16bef65.png";